import { createContext, useContext } from "react";

interface PanelContextValue {
  isInsidePanel: boolean;
  openFullPage: (() => void) | null;
}

const PanelContext = createContext<PanelContextValue>({
  isInsidePanel: false,
  openFullPage: null,
});

export function PanelContextProvider({
  children,
  openFullPage,
}: {
  children: React.ReactNode;
  openFullPage: (() => void) | null;
}) {
  return (
    <PanelContext.Provider value={{ isInsidePanel: true, openFullPage }}>
      {children}
    </PanelContext.Provider>
  );
}

export function useIsInsidePanel() {
  return useContext(PanelContext).isInsidePanel;
}

export function useOpenFullPage() {
  return useContext(PanelContext).openFullPage;
}
